import React from 'react';
import styles from './Features.module.css';

const AIConciergeFeaturesComponent = () => {
  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h1 className={styles.title}>
          AI Concierge: Smart, Fast, and{" "}
          <span className={styles.highlight}>Always Available</span>
        </h1>
        <p className={styles.subtitle}>
          Transform guest interactions with AI-powered Voice Agents that handle
          bookings, modifications, and inquiries instantly—enhancing service
          efficiency and boosting engagement.
        </p>
      </div>

      <div className={styles.featuresGrid}>
        <div className={`${styles.featureCard} ${styles.card15Percent}`}>
          <div className={styles.cardContent}>
            <img
              src="https://ik.imagekit.io/hotelzifyprod/bookings_percent.svg"
              alt="Bookings"
              style={{ width: "100%", height: "100%", objectFit: "cover" }}
            />
          </div>
        </div>

        <div className={`${styles.featureCard} ${styles.cardOmnichannel}`}>
          <div className={styles.cardContent}>
            <img
              src="https://ik.imagekit.io/hotelzifyprod/ominichannel.svg"
              alt="Omnichannel"
              style={{ width: "100%", height: "100%", objectFit: "cover" }}
            />
          </div>
        </div>

        <div className={`${styles.featureCard} ${styles.card230Percent}`}>
          <div className={styles.cardContent}>
            <img
              src="https://ik.imagekit.io/hotelzifyprod/conversion.svg"
              alt="conversion"
              style={{ width: "100%", height: "100%", objectFit: "cover" }}
            />
          </div>
        </div>

        <div className={`${styles.featureCard} ${styles.cardScalability}`}>
          <div className={styles.cardContent}>
            <img
              src="https://ik.imagekit.io/hotelzifyprod/scalability.svg"
              alt="scalability"
              style={{ width: "100%", height: "100%", objectFit: "cover" }}
            />
          </div>
        </div>

        <div className={`${styles.featureCard} ${styles.card96Percent}`}>
          <div className={styles.cardContent}>
            <img
              src="https://ik.imagekit.io/hotelzifyprod/automation.svg"
              alt="automation"
              style={{ width: "100%", height: "100%", objectFit: "cover" }}
            />
          </div>
        </div>

        <div className={`${styles.featureCard} ${styles.cardMultilingual}`}>
          <div className={styles.cardContent}>
            <img
              src="https://ik.imagekit.io/hotelzifyprod/multilingual_support.svg"
              alt="multi_lingual"
              style={{ width: "100%", height: "100%", objectFit: "cover" }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AIConciergeFeaturesComponent;
